import API from "@/services/api";
export default {
  getPosts() {
    return API().get("posts");
  },
  getPostCount() {
    return API().get("postcount");
  },
  getPostsFromDate(fromDate) {
    return API().get("posts?from=" + fromDate);
  },
  addPost(post) {
    return API().post("addPost", {
      post: post
    });
  }
};
